import { RemoteExportAccessReportExcel } from 'data/usecases';
import { ExportAccessReportExcelUseCaseInterface } from 'domain/usecases';
import { makeApiUrlExportAccessReportExcel } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeExportAccessReportExcel =
  (): ExportAccessReportExcelUseCaseInterface =>
    new RemoteExportAccessReportExcel(
      makeApiUrlExportAccessReportExcel(),
      makeAxiosHttpClient(),
    );
